if (!customElements.get('product-addons')) {
	class ProductAddons extends HTMLElement {
		constructor() {
			super();
			this.animating = false;
		}

		connectedCallback() {


      if (this.dataset.count === 'false') {
				const parentModule = this.closest('[data-section="single-addons"]');
				if (parentModule) parentModule.remove();
				return;
			} else {
        this.classList.remove('hidden')
      }

			this.addEventListener('submit', this.handleSubmit.bind(this), true);
		}

		handleSubmit(event) {
			const form = event.target;
			if (!(form instanceof HTMLFormElement)) return;

			const cartIcon = form.querySelector('[data-cart-button]');
			if (!cartIcon || this.animating) return;

			event.preventDefault();

			this.animating = true;

			const spans = cartIcon.querySelectorAll('span');

			cartIcon.classList.add('translate-y-[30px]');

			setTimeout(() => {
				spans.forEach(span => span.classList.toggle('hidden'));
				cartIcon.classList.remove('translate-y-[30px]');
				setTimeout(() => {
					setTimeout(() => {
						cartIcon.classList.add('translate-y-[30px]');
						setTimeout(() => {
							spans.forEach(span => span.classList.toggle('hidden'));
							cartIcon.classList.remove('translate-y-[30px]');
							setTimeout(() => {
								this.animating = false;
							}, 500);
						}, 400);
					}, 2000);
				}, 500);
			}, 400);
		}
	}

	customElements.define('product-addons', ProductAddons);
}
